module.exports = __webpack_public_path__ + "img/return-ship.3727420f.svg";